const ACTION_META = {
  ORG_SOFT_DELETE: {
    label: 'Organization Deleted',
    severity: 'danger',
    group: 'lifecycle',
    icon: '⛔',
  },
  ORG_RESTORE: {
    label: 'Organization Restored',
    severity: 'success',
    group: 'lifecycle',
    icon: '↺',
  },
  SUBORG_SOFT_DELETE: {
    label: 'Suborganization Deleted',
    severity: 'danger',
    group: 'lifecycle',
    icon: '⛔',
  },
  SUBORG_RESTORE: {
    label: 'Suborganization Restored',
    severity: 'success',
    group: 'lifecycle',
    icon: '↺',
  },
  LOGIN_DENIED_ORG_DELETED: {
    label: 'Login Blocked',
    severity: 'warning',
    group: 'auth',
    icon: '⛔',
  },
  ACCESS_REVOKED_ORG_DELETED: {
    label: 'Access Revoked',
    severity: 'warning',
    group: 'auth',
    icon: '⛔',
  },
}

const KNOWN_METADATA_FIELDS = {
  cascade_suborg_count: 'Affected suborganizations',
  restored_children: 'Restored child entities',
}

const toTitleCase = (value = '') => {
  return String(value)
    .toLowerCase()
    .replace(/[-\s]+/g, '_')
    .split('_')
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ')
}

const isObjectLike = (value) => value !== null && typeof value === 'object'

const normalizeAuditMetadata = (metadata) => {
  if (metadata === null || metadata === undefined || metadata === '') return null

  if (typeof metadata === 'string') {
    const trimmed = metadata.trim()
    if (!trimmed) return null

    try {
      return JSON.parse(trimmed)
    } catch {
      return trimmed
    }
  }

  return metadata
}

const formatMetadataValue = (value) => {
  if (value === null || value === undefined || value === '') return '—'
  if (Array.isArray(value) || isObjectLike(value)) {
    return JSON.stringify(value, null, 2)
  }
  return String(value)
}

export const formatAuditTimestamp = (value) => {
  if (!value) return 'Not available'

  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return String(value)

  return parsed.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

export const formatAuditActor = (log) => {
  const actorName = String(log?.actor_name ?? '').trim()
  if (actorName) return actorName

  const actorUsername = String(log?.actor_username ?? '').trim()
  if (actorUsername) return actorUsername

  const actorEmail = String(log?.actor_user_email ?? '').trim()
  if (actorEmail) return actorEmail

  const actorId = log?.actor_user_id
  if (actorId !== null && actorId !== undefined && actorId !== '') return `User #${actorId}`

  return 'System'
}

export const getAuditActionMeta = (action) => {
  const normalizedAction = String(action || '').trim().toUpperCase()
  if (!normalizedAction) {
    return {
      label: 'Unknown Action',
      severity: 'neutral',
      group: 'other',
      icon: '•',
    }
  }

  if (ACTION_META[normalizedAction]) {
    return ACTION_META[normalizedAction]
  }

  return {
    label: toTitleCase(normalizedAction),
    severity: 'neutral',
    group: 'other',
    icon: '•',
  }
}

export const getAuditOutcomeMeta = (success) => {
  if (success === true) {
    return { label: 'Success', className: 'success', icon: '✓' }
  }

  if (success === false) {
    return { label: 'Failure', className: 'failure', icon: '!' }
  }

  return { label: 'Unknown', className: 'neutral', icon: '•' }
}

export const formatAuditMetadata = (metadata) => {
  const normalizedMetadata = normalizeAuditMetadata(metadata)

  if (normalizedMetadata === null) return []

  if (!isObjectLike(normalizedMetadata) || Array.isArray(normalizedMetadata)) {
    return [{
      key: 'metadata',
      label: 'Metadata',
      value: formatMetadataValue(normalizedMetadata),
      isCode: Array.isArray(normalizedMetadata) || isObjectLike(normalizedMetadata),
    }]
  }

  return Object.entries(normalizedMetadata).map(([key, value]) => ({
    key,
    label: KNOWN_METADATA_FIELDS[key] || toTitleCase(key),
    value: formatMetadataValue(value),
    isCode: Array.isArray(value) || isObjectLike(value),
  }))
}

